const extension = ".png";
const svgExtension = ".svg"

export enum ImagePaths {
    WITS = `assets/images/WITS${extension}`,
    NMU = `assets/images/NMU${extension}`,
    UJ = `assets/images/UJ${extension}`,
    UP = `assets/images/UP${extension}`,
    RUR = `assets/images/RUR${extension}`,
    CT = `assets/images/CT${extension}`,
    CPU = `assets/images/CPU${extension}`,
    UFS = `assets/images/UFS${extension}`,
    BCU = `assets/images/BCU${extension}`,
    DEFAULT = `assets/images/AD-HOC${extension}`,
    UNISA = `assets/images/UNISA${extension}`,
    UKZN = `assets/images/UKZN${extension}`,
    BBD_LOGO_LIGHT = `/assets/bbd-logo-side-nav-light${svgExtension}`,
    BBD_LOGO = `/assets/bbd-logo-side-nav${svgExtension}`,
    BBD_BURSARY_LIGHT = `assets/bbd-bursary-logo-light${svgExtension}`,
    BBD_BURSARY_DARK = `assets/bbd-bursary-logo-dark${svgExtension}`,
    UKUKHULA_NAV_BAR_LIGHT = `assets/nav-bar-logo-white${svgExtension}`,
    UKUKHULA_NAV_BAR_DARK = `assets/nav-bar-logo${svgExtension}`,
    DEFAULT_EVENT_IMAGE = `assets/images/BBD-Mailer-header-Vacation-900x257${extension}`,
    BBD_LOGO_DARK = `assets/images/BBD-Logo-Dark${extension}`
}
